import React from "react"
import Heading from "../../common/Heading"
import "./recent.css"
import RecentCard from "./RecentCard"
import { useLanguage } from "../../../context/LanguageContext"

const Recent = () => {
  const { content } = useLanguage()
  const { recent } = content.home

  return (
    <>
      <section className='recent padding'>
        <div className='container'>
          <Heading title={recent.title} subtitle={recent.subtitle} />
          <RecentCard />
        </div>
      </section>
    </>
  )
}

export default Recent
